module.exports = __webpack_public_path__ + "static/img_2025-eb7b17f392b31043a04ba0d5904f0d70.webp";